import { InputSelect } from '@welbe/web-design-system';
import { BrokersContext } from 'contexts/Brokers/Brokers';
import { Fragment, useContext, useMemo } from 'react';

export const SelectCompanies = () => {
	const {
		availableCompanies,
		onSelectedCompany,
		selectedCompany,
		isLoadingAvailableCompanies,
		isBroker,
		isLoadingChangeCompany,
	} = useContext(BrokersContext);

	const options = useMemo(() => {
		return (
			availableCompanies.map((company: any) => ({
				id: company.id,
				name: company.fancyName,
			})) || []
		);
	}, [availableCompanies]);

	if (!isBroker) {
		return <></>;
	}

	return (
		<Fragment data-testid="menu-companies">
			<InputSelect
				disabled={isLoadingAvailableCompanies || isLoadingChangeCompany}
				loading={isLoadingAvailableCompanies || isLoadingChangeCompany}
				options={options}
				searchable
				showEmpty={false}
				onChange={(value: any) => onSelectedCompany(value)}
				value={options.find((company) => company.id === selectedCompany.id)}
			/>
		</Fragment>
	);
};
